module.exports = __webpack_public_path__ + "img/red-river.fdcd0414.svg";